export const ROUTES_PATH = {
  ADMIN: 'admin',
  USERS: 'users',
  CUSTOM_FIELDS: 'custom-fields',
  PAYMENT: 'payment',
};

export const ADMIN_ROUTES_PATH = {
  USERS: `${ROUTES_PATH.ADMIN}/${ROUTES_PATH.USERS}`,
  CUSTOM_FIELDS: `${ROUTES_PATH.ADMIN}/${ROUTES_PATH.CUSTOM_FIELDS}`,
  PAYMENT: `${ROUTES_PATH.ADMIN}/${ROUTES_PATH.PAYMENT}`,
};
